<template>
  <SkeletonBlock
    :is-active="categoryStore.isSkeletonActive"
    :width="width"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  import { useCategoryStore } from '@/shared/store';

  const { isMobile } = useScreenSize();

  const width = computed(() => {
    if (isMobile.value) {
      return 'calc(50% - 4px)';
    }

    return 88;
  });

  const categoryStore = useCategoryStore();
</script>

<style lang="scss"></style>
